import { render } from "./detailTable.vue?vue&type=template&id=0cacc949"
import script from "./detailTable.vue?vue&type=script&lang=js"
export * from "./detailTable.vue?vue&type=script&lang=js"

import "./detailTable.vue?vue&type=style&index=0&id=0cacc949&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__